<script setup lang="ts">
import PejerDonutChart from 'pejer/src/components/Chart/PejerDonutChart.vue'
import { defaultUrls } from 'pejer/src/stores/config'
import { EndpointResponse } from 'pejer/src/types/base'
import { MaybeRef } from 'vue'

defineProps<{
  data: MaybeRef<EndpointResponse<(typeof defaultUrls)['businesses']['stats']>>
  horizontal?: boolean
}>()
</script>
<template>
  <PejerDonutChart
    :data="data"
    :horizontal="horizontal"
    title="Onboarding"
    :data-options="[
      {
        key: 'tosNotAcceptedCount',
        name: 'Terms not accepted',
        color: '#FF9999',
      },
      {
        key: 'missingSignaturesCount',
        name: 'Missing signatures',
        color: '#F59E0B',
      },
      {
        key: 'onboardedCount',
        name: 'Onboarded successfully',
        color: '#13b982',
      },
    ]"
  />
</template>
